module.exports = __webpack_public_path__ + "img/invite.21c89d92.svg";